const optionKeys = [
    'backgroundVariant',
    'cardBackgroundColor',
    'hideOnDesktop',
    'hideOnMobile',
    'noUnderline',
    'listTickVariant',
    'titleVariant'
];

/** Creates an object from common options passed in to allow for easy access */
export default (options) => {
    if (!options?.length) return null;
    return options.reduce((optionMap, currentValue) => {
        const keys = Object.keys(currentValue).filter((k) =>
            optionKeys.includes(k)
        );

        const newOptionMap = { ...optionMap };
        keys.forEach((k) => {
            newOptionMap[k] = currentValue[k];
        });
        return newOptionMap;
    }, {});
};
